export const PARAM_PAGE = 'section'
export const PARAM_SUB_PAGE = 'sub_section'
export const NAME_DIRECTORY = 'lobby'

export const PRAGMATIC_LIVE_TERM = 'pragmatic-play-live'

export const VIEW_MODE = {
  DEFAULT: 'default',
  EXPAND: 'expand',
}

export const MODEL_TYPE = {
  SUBSECTION: 'subsection',
  SUBSECTIONS: 'subsections',
  SECTION: 'section',
  TOURNAMENTS: 'tournaments',
  PRAGMATIC_BANNER: 'pragmaticBanner',
  PROMOTIONS: 'promotionBanner',
  SLIDE: 'slide',
}

export const LIST_TYPE = {
  COLLECTION: {
    NAME: 'collection',
    FIELD: 'collections',
    PAGINATION: 6,
  },
  PROVIDER: {
    NAME: 'provider',
    FIELD: 'providers',
    PAGINATION: 15,
  },
  GAME: {
    NAME: 'game',
    FIELD: 'games',
    PAGINATION: 18,
  },
}

export const QUERY = {
  LAYOUT: 'layout',
  PAGE: 'page',
  DISPLAY_MODE: 'displayMode',
}

export const GAME_TYPE = {
  LIVE: 'live',
}

export const AUTO_CONDITION = {
  FAVOURITE: 'favourite',
  LAST_GAMES: 'last_games',
}

export const DISPLAY_MODE = {
  BY_LAYOUT: 'byLayout',
  LIST: 'list',
}

export const VIEW_TYPE = {
  GRID: 'grid',
  SLIDER: 'slider',
}

export const ENUM_CATEGORY = {
  RECOMMENDED: {
    NAME: 'recommended',
    URL: '/slots-games/beton-recommended',
    TERM: 'recommended',//?
  },
  RECOMMENDED_LIVE: {
    NAME: 'live recommended',
    URL: '/live-games/recommended',
    TERM: 'live-recommended',//?
  },
  POPULAR: {
    NAME: 'popular',
    URL: '/slots-games/popular',
    TERM: 'popular',
  },
  COLLECTIONS: {
    NAME: 'catalog',
    URL: '/catalog',
    TERM: 'catalog',
  },
  PROVIDERS: {
    NAME: 'providers',
    URL: '/vendors',
    TERM: 'vendors',
  },
  LIVE: {
    NAME: 'live',
    URL: '/live-games',
    TERM: 'live-games',
  },
  SLOTS: {
    NAME: 'slots',
    URL: '/slots-games',
    TERM: 'slots-games',
  },
  FAVOURITES: {
    NAME: 'favourite',
    URL: '/favourite',
    TERM: 'favourite',
  },
  LAST: {
    NAME: 'lastgames',
    URL: '/lastgames',
    TERM: 'lastgames',
  },
  TOP: {
    NAME: 'top',
    URL: '/slots-games/top',
    TERM: 'top',
  },
  NEW: {
    NAME: 'new',
    URL: '/slots-games/new',
    TERM: 'new',
  },
  LIVE_NEW: {
    NAME: 'live-games-new',
    // URL: '/live-games/live-games-new',
    URL: '/live-games/live-new',
    TERM: 'live-games-new',
  },
  LIVE_TABLE: {
    NAME: 'table',
    URL: '/slots-games/table',
    // URL: '/live-games/table',
    TERM: 'table',
  },
  PROMOTIONS: {
    NAME: 'promotions',
    URL: '/promotions',
    TERM: 'promotions',
  },
  FOR_BONUSES: {
    NAME: 'for-bonuses',
    URL: '/slots-games/for-bonuses',
    TERM: 'for-bonuses',
  },
  ROULETTE: {
    NAME: 'roulette',
    URL: '/live-games/roulette',
    TERM: 'roulette',
  },
  BLACKJACK: {
    NAME: 'blackjack',
    URL: '/live-games/blackjack',
    TERM: 'blackjack',
  },
  PRAGMATIC: {
    NAME: 'pragmatic-play',
    URL: '/vendors/pragmatic-play',
    TERM: 'pragmatic-play',
  },
  EGT: {
    NAME: 'egt',
    URL: '/vendors/egtDigital',
    TERM: 'egt',
  },
  OAKS: {
    NAME: '3-oaks',
    URL: '/vendors/3oaksgaming',
    TERM: '3-oaks',
  },
  PLAYSON: {
    NAME: 'playson',
    URL: '/vendors/playson',
    TERM: 'playson',
  },
}

export const FILTER = {
  PRESET: {
    DEFAULT_GAMES: 'default-games',
  },
  MODE: {
    SIMPLE: 'simple',
  },
  TYPE: {
    PROVIDER: 'provider',
    COLLECTION: 'collection',
    SUBSECTION: 'subsection',
  },
  EVENT: 'send-filter',
  TEMPLATE: {
    POPULAR: 'popular',
    SIZE_BET: 'size-bet',
    PROVIDER: 'provider',
  },
}

export const PRAGMATIC_LIVE_TABLE_TYPE = {
  BACCARAT: 'BACCARAT', // + 2 Баккара
  BLACKJACK: 'BLACKJACK', // + 3 Блекджек
  ONEBJ: 'ONEBJ', // - 4 One блекджек
  ROULETTE: 'ROULETTE', // + 1 Рулетка, MegaRoulette (7)
  SNAKESANDLADDERSLIVE: 'SNAKESANDLADDERSLIVE', // + 11 Snakes&Ladders
  SicBo: 'SicBo', // - 5 SicBO
  MEGAWHEEL: 'MEGAWHEEL', // - 6 Mega Wheel
  DRAGONTIGER: 'DRAGONTIGER', // - 8 DragonTiger
  BINGO: 'BINGO',
  BOOMORBUST: 'BOOMORBUST',
  SPACEMAN: 'SPACEMAN',
  SWEETBONANZA: 'SWEETBONANZA', // + 10 Sweet Bonanza
  ANDARBAHAR: 'ANDARBAHAR', // + 9 AndharBahar
}

export const EXCLUSION_SUB_PAGES = ['live-games-all', 'all-slot-games']
